import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  jcSE: {
    justifyContent: "space-evenly",
  },
  cardStyle: {
    cursor: "pointer",
    backgroundColor: "#FFF8F8",
    border: "1px solid black",
    height: "-webkit-fill-available",
    "&:hover": {
      backgroundColor: "#FFD7D7",
    },
  },
  cardSelected: {
    cursor: "pointer",
    backgroundColor: "#FFD7D7",
    border: "1px solid black",
    height: "-webkit-fill-available",
  },
  G1: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexDirection: "row",
  },
  G2: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "9rem",
    maxWidth: "12rem",
    flexShrink: 0,
    whiteSpace: "normal",
    overflow: "visible",
    padding: "2px",
    textAlign: "center",
  },
  G3: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  cardContent: {
    height: "inherit",
    padding: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  count: {
    textAlign: "center",
    fontWeight: 500,
    fontSize: "1.1rem",
  },
  title: {
    textAlign: "center",
    fontSize: "0.8rem",
    fontWeight: 500,
  },
}));
